import type { NextApiRequest, NextApiResponse } from 'next'
import type {
  KlarnaOrder,
  KlarnaUpdateOrderRequest,
  UpdateOrderPayload,
  UpdateOrderResponse
} from 'ecosystem'
import { klarnaApiCall } from 'api'

export const klarnaPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<UpdateOrderResponse | { error: string }>
) => {
  const { klarnaPayload }: UpdateOrderPayload = JSON.parse(req.body)

  if (!klarnaPayload) {
    res.status(400).json({ error: 'Wrong payload' })
    return
  }

  const { orderId, ...updatedOrder } = klarnaPayload

  const { error: getOrderError, data: currentKlarnaOrder } = await klarnaApiCall<
    KlarnaOrder,
    undefined
  >('get', {
    orderId
  })

  if (getOrderError || !currentKlarnaOrder) {
    res.status(400).json({ error: getOrderError || 'Unknown error' })
    return
  }

  const payload: KlarnaUpdateOrderRequest = {
    ...currentKlarnaOrder,
    ...updatedOrder
  }

  const { error, data } = await klarnaApiCall<KlarnaOrder, KlarnaUpdateOrderRequest>('update', {
    payload,
    orderId
  })

  if (error || !data) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ klarnaResponse: data } as UpdateOrderResponse)
}
